import { toast } from 'sonner';
import type { Session } from '@supabase/supabase-js';
import { supabase } from './supabase';
import { shouldRejectGithubUser } from './githubAuthAllowlist';

export async function enforceGithubSessionAllowlist(
  session: Session | null,
  options?: { toastOnReject?: boolean },
): Promise<Session | null> {
  if (!session?.user) return null;
  if (!shouldRejectGithubUser(session.user)) return session;

  await supabase.auth.signOut();
  if (options?.toastOnReject !== false) {
    toast.error('This GitHub account is not authorized for Engine.');
  }
  return null;
}
